/*
 * @Author: Zhouqi
 * @Date: 2025-11-03 19:40:27
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import dynamic from 'next/dynamic';
import React from 'react';

import VideoEditSkeleton from '@/3.0/ai-video-edit/_components/video-edit-skeleton';
import { Introduction } from '@/components/container';
import DelayedRender from '@/components/DelayRender';
import Footer from '@/components/Footer';
import Layout from '@/components/layout';
import SEOHead from '@/landing/components/SEOHead';
import { createSoftwareAppSchema } from '@/landing/utils/structuredData';

const PRELOAD_POSTER =
  'https://assets.falcocut.ai/ai-video-editor/product-integration.png';

const VideoEdit = dynamic(() => import('@/3.0/ai-video-edit/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <VideoEditSkeleton />
    </DelayedRender>
  ),
});

const SEOSections = dynamic(() => import('../../3.0/ai-video-edit/seo'), {
  ssr: true,
});

const PAGE_TITLE = 'AI Video Editor - Edit Videos with AI | FalcoCut';
const META_DESCRIPTION =
  'Edit videos with AI-powered tools in minutes. Product integration, character replacement, background swap, style adjustment, and subtitle removal — all in one platform. Try FalcoCut AI Video Editor free.';
const CURRENT_URL = 'https://falcocut.ai/ai-video-editor';

const structuredData = createSoftwareAppSchema({
  name: 'FalcoCut AI Video Editor',
  description: META_DESCRIPTION,
  url: CURRENT_URL,
  ratingValue: '4.8',
  ratingCount: '2650',
  featureList: [
    'AI product integration',
    'Character replacement',
    'Background replacement',
    'Style adjustment',
    'Subtitle removal',
    'Cloud-based video editing',
  ],
});

const VideoEditPage: React.FC & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
  getExtraContent?: () => React.ReactNode;
} = () => {
  return (
    <>
      <SEOHead
        title={PAGE_TITLE}
        description={META_DESCRIPTION}
        url={CURRENT_URL}
        imageAlt="FalcoCut AI Video Editor"
        publishedTime="2026-02-13"
        modifiedTime="2026-02-13"
        structuredData={structuredData}
        preloadImages={[PRELOAD_POSTER]}
      />

      {/* 功能页，勿动 */}
      <VideoEdit />
    </>
  );
};

VideoEditPage.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

VideoEditPage.getExtraContent = () => {
  return (
    <Introduction>
      <SEOSections />
      <Footer />
    </Introduction>
  );
};

export const getStaticProps = async () => {
  return {
    props: {},
  };
};

export default VideoEditPage;
